<template>
  <TsCard :data-testid="baseDataTestId + 'section'" append-class="border-none shadow-none rounded-sm px-5 pt-5 pb-6 min-w-[408px] max-w-[408px] w-full h-full">
    <TsRow append-class="m-0 items-center gap-3 pb-3" :data-testid="baseDataTestId + 'content'">
      <TsImage width="48" height="48" :src="props.image" alt="trophy" :data-testid="baseDataTestId + 'image'" loading="lazy"/>
      <TsTypography append-class="mb-0" as="h2" :data-testid="baseDataTestId + 'heading'">
        <div v-html="props.heading" />
      </TsTypography>
    </TsRow>
    <TsTypography append-class="mb-0 text-natural-grey" :data-testid="baseDataTestId + 'description'">
      <div v-html="props.description" />
    </TsTypography>
  </TsCard>
</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props = {
  image?: string;
  heading?: string;
  description?: string;
};

const props = withDefaults(defineProps<Props>(), {
  image: "/images/trophy.png",
  heading: "Awarded Best of 2021",
  description: "Our tools excelled in features and performance."
});

const baseDataTestId = "card-detail-";

</script>